import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Settings from "../Settings/Settings";
import "./Navigation.css";

export default function Navigation() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { key: "home", path: "/" },
    { key: "products", path: "/products" },
    { key: "services", path: "/services" },
    { key: "blog", path: "/blog" },
    { key: "news", path: "/news" },
    { key: "contact", path: "/contact" },
    { key: "dashboard", path: "/dashboard" },
    { key: "download", path: "/download" },
  ];

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <Link
            key={item.key}
            to={item.path}
            onClick={handleNavClick}
            className={`nav-link ${
              location.pathname === item.path ? "active" : ""
            }`}
          >
            {t(`nav.${item.key}`)}
          </Link>
        ))}
        <div className="nav-settings mobile-only">
          <Settings />
        </div>
      </div>

      <button
        className={`menu-toggle ${isMenuOpen ? "open" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label={t("nav.toggleMenu")}
        aria-expanded={isMenuOpen}
      >
        <span className="menu-icon"></span>
      </button>

      <div className="nav-settings desktop-only">
        <Settings />
      </div>

      {isMenuOpen && (
        <div className="nav-overlay" onClick={handleNavClick}></div>
      )}
    </nav>
  );
}
